import { ICorporatePolicy } from "@/core/interfaces/corporatePolicy.interface";
import { MutationTree } from "vuex";
import { ICorporatePolicyState, IPolicyBuilderConfig } from "../types";

const mutations: MutationTree<ICorporatePolicyState> = {
  setPolicyBuilderConfig(state, payload: IPolicyBuilderConfig | null) {
    state.policyBuilderConfig = payload;
  },
  setFetchingPolicyBuilderConfig(state, payload: boolean) {
    state.isFetchingPolicyBuilderConfig = payload;
  },
  setCorporatePolicies(state, payload: ICorporatePolicy[]) {
    state.corporatePolicies = payload;
  },
  setFetchingCorporatePolicies(state, payload: boolean) {
    state.isFetchingCorporatePolicies = payload;
  },
  setSelectedCorporatePolicy(state, payload: ICorporatePolicy | null) {
    state.selectedCorporatePolicy = payload;
  },
  setFetchingCorporatePolicy(state, payload: boolean) {
    state.isFetchingCorporatePolicy = payload;
  },
  setCorporatePolicyActionLoading(state, payload: boolean) {
    state.corporatePolicyActionLoading = payload;
  },
};

export default mutations;
